import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import itTranslation from './locales/it.json';
import enTranslation from './locales/en.json';
import frTranslation from './locales/fr.json';
import esTranslation from './locales/es.json';

i18n.use(initReactI18next).init({
  resources: {
    it: { translation: itTranslation },
    en: { translation: enTranslation },
    fr: { translation: frTranslation },
    es: { translation: esTranslation }
  },
  lng: localStorage.getItem('language') || "it", // Load from localStorage if available
  fallbackLng: "it"
});

export default i18n;
